<template>
  <v-col
    v-if="$vuetify.breakpoint.name == 'xs' || $vuetify.breakpoint.name == 'sm'"
    cols="12"
    class="pa-0 align-center"
    style="height: 100vh; display: flex;margin-top: -70px;"
  >

    <h2 class="text-center" style="width: 100%;">
      <v-icon x-large class="mb-5">mdi-close-octagon-outline</v-icon>
      <br />
      Not available on mobile
    </h2>
  </v-col>
  <v-container v-else class="col-12">
    <edit-form
      v-if="isOpenEditDialog"
      v-model="isOpenEditDialog"
      @edit="loadAllTemplates"
      :is-show-to-project="false"
      :method="'replace'"
      :languages='languages'
    >
      <template #title>
        Edit Mail Templates:
      </template>
      <template #button>
        edit
      </template>
    </edit-form>
    <edit-form
      v-if="isOpenCopyDialog"
      v-model="isOpenCopyDialog"
      :is-show-to-project="true"
      :languages='languages'
    >
    </edit-form>
    <edit-form
      v-if="isOpenExportDialog"
      v-model="isOpenExportDialog"
      method="export"
      :languages="languages"
      @edit="$downloadText($event, `mail_template_export_${Date.now()}.json`)"
    >
      <template #title>
        Export Mail Templates:
      </template>
      <template #button>
        Export
      </template>
    </edit-form>
    <v-row cols="12" class="v-card v-sheet theme--light mx-auto fill-height" :style="`min-height: calc(100vh - 24px - ${!$store.state.auth.default_user ? '0px' : '24px'})`">
      <v-col cols="4">
        <v-data-table
          v-model="selected"
          :headers="headers.template"
          :items="filteredItems"
          :disable-pagination="true"
          fixed-header
          hide-default-footer
          single-select
          item-key="template_id"
          class="mail-template-dt"
          show-select
          :search="search"
          @item-selected="selectTemplate"
          :height="`calc(100vh - 160px - ${!$store.state.auth.default_user ? '0px' : '24px'})`"
        >
          <template v-slot:top>

            <v-row>
              <select-project
                v-model="entity_id"
                class="col-5"
              >
              </select-project>

              <v-select
                v-model="filters.language"
                :items="languages"
                label="Language"
                required
                hide-details
                class="col-4"
                style="z9-index: 800"
              ></v-select>

              <v-btn class="col-3 mt-3" color="success" @click="newTemplate()">
                <v-icon left>mdi-pencil</v-icon>
                New
              </v-btn>

              <v-text-field
                label="Search"
                v-model="search"
                hide-details
                class="col-12 pt-1"
              />
            </v-row>
          </template>
          <template v-slot:body.prepend>
            <tr class="grey lighten-3">
              <td></td>
              <td
                v-for="header in headers.template"
                :key="header.text"
              >
                <v-select
                  v-if="filtersOfTable.hasOwnProperty(header.value) && filtersOfTable[header.value].type == 'select'"
                  hide-details
                  dense
                  small
                  multiple
                  clearable
                  persistent-hint
                  return-object
                  single-line
                  class="data-table-bonus-filter-select"
                  :items="columnValueList(header.value)"
                  v-model="filtersOfTable[header.value].data"
                ></v-select>
              </td>
            </tr>
          </template>
          <template v-slot:header.action="{ item }">
            <v-icon
              v-if="$store.state.auth.checkAccess({key: 'mail_template_update', value: true})"
              small
              @click="copy()"
            >
              mdi-content-copy
            </v-icon>
          </template>
          <template v-slot:header.data-table-select="{ item }">
            <v-btn
              v-if="$store.state.auth.checkAccess({key: 'mail_template_update', value: true})"
              icon
              @click="update()"
            >
              <v-icon small>
                mdi-pencil
              </v-icon>
            </v-btn>
            <v-btn
              v-if="$store.state.auth.checkAccess({key: 'mail_template_export', value: true})"
              icon
              @click="isOpenExportDialog = true"
            >
              <v-icon small>
                mdi-export-variant
              </v-icon>
            </v-btn>
            <v-btn
              v-if="$store.state.auth.checkAccess({key: 'mail_template_import', value: true})"
              icon
              @click="isImporting = true"
            >
              <v-icon small>
                mdi-import
              </v-icon>
            </v-btn>
          </template>
          <template v-slot:item.action="{ item }">
            <v-icon
              v-if="$store.state.auth.checkAccess({key: 'mail_template_update', value: true})"
              small
              @click="deleteTemplate(item)"
            >
              delete
            </v-icon>
          </template>
        </v-data-table>
      </v-col>
      <v-col cols="8">
        <update-form
          v-if="template"
          :template="template"
          :tagsList="tags"
          v-model="loadingTemplate"
          :has-notification-access="hasNotificationAccess"
          :notification-options="notificationOptions"
          @loadMailTemplates="loadMailTemplates"
          @loadMailTemplate="loadMailTemplate"
          :save="saveTemplate"
        />
      </v-col>
    </v-row>

    <v-dialog
      v-model="isImporting"
      max-width="900"
    >
      <import-form
        v-if="isImporting"
        :is-loading="isImportLoading"
        @cancel="isImporting = false"
        @import="onImport"
      />
    </v-dialog>
  </v-container>
</template>

<style>
  .v-data-table.mail-template-dt td,
  .v-data-table.mail-template-dt th {
    padding: 0 5px !important;
  }

  .data-table-bonus-filter-select {
    max-width: 150px;
    font-size: 12px;
    padding: 0;
    margin: 0;
  }

  .v-data-table.mail-template-dt th {
    white-space: nowrap;
  }
</style>
<script>
  import jQuery from 'jquery'
  import { debounce, get } from 'lodash'
  import { API } from '@/utils/api'
  import SelectProject from '@/components/core/SelectProject/SelectProject.vue'

  global.jQuery = jQuery

  export default {
    components: {
      SelectProject,
      UpdateForm: () => import('@/components/mail-template/UpdateForm'),
      EditForm: () => import('@/components/mail-template/EditForm.vue'),
      ImportForm: () => import('@/components/mail-template/ImportForm.vue'),
    },

    data: () => ({
      isOpenCopyDialog: false,
      isOpenEditDialog: false,
      isOpenExportDialog: false,
      isImporting: false,
      isImportLoading: false,
      selected: [],
      notificationOptions: [],
      search: '',
      entity_id: null,
      filtersD: {},
      filters: { language: 'All' },
      filtersOfTable: {
        'settings.tag': { data: [], type: 'select' },
      },
      template: false,
      loadingTemplate: true,
      items: [],
    }),
    computed: {
      tags: function () {
        return this.columnValueList('settings.tag')
      },
      languages () {
        return [ 'All', ...this.items.map((item) => item.translation.split(',')).flat() ]
      },
      headers () {
        return {
          template: [
            { text: 'Template ID', value: 'template_id', sortable: true },
            { text: 'Tag', value: 'settings.tag', sortable: true },
            { text: 'Name', value: 'name', sortable: true },
            { text: 'Language', value: 'translation', sortable: true, filter: this.findLanguage },
            { text: 'Explain', align: 'left', sortable: false, value: 'explain' },
            { text: '', align: 'left', sortable: false, value: 'action' },
          ]
        }
      },
      filteredItems: function () {
        return this.items.filter(d => {
          return Object.keys(this.filtersOfTable).every(f => {
            const filterValues = this.filtersOfTable[f].data
            const targetValue = get(d, f)

            if (!filterValues || filterValues.length === 0) return true

            if (Array.isArray(targetValue)) {
              return targetValue.some(val => filterValues.includes(val))
            }

            if (typeof targetValue === 'boolean') {
              return (
                (filterValues.includes(true) && targetValue === true) ||
                (filterValues.includes(false) && targetValue === false)
              )
            }

            if (typeof targetValue === 'string') {
              return filterValues.some(fv =>
                fv.toLowerCase() === targetValue.toLowerCase() ||
                targetValue.toLowerCase().includes(fv.toLowerCase())
              )
            }

            return filterValues.includes(targetValue)
          })
        })
      },

      hasNotificationAccess() {
        return this.$store.state.auth.checkAccess({ key: 'notification_center', value: true })
      },
    },

    watch: {
      entity_id (val) {
        this.entity_id = val
        this.loadMailTemplates(true)
      },
      filtersOfTable: {
        handler: debounce(function () {
          this.filtersD = this.filtersOfTable
        }, 800),
        deep: true,
      },
    },

    methods: {
      copy () {
        this.isOpenCopyDialog = true
      },
      update () {
        this.isOpenEditDialog = true
      },
      findLanguage (language) {
        return this.filters.language === 'All' ? true : language.split(',').includes(this.filters.language)
      },
      async saveTemplate (create = false) {
        this.loadingTemplate = true
        try {
          const { translation, ...template } = this.template
          const updatedTemplate = await API.call('/mail/template/update.json', create ? this.template : template, null, this.template.entity_id)
          this.template = { translation: [], ...updatedTemplate.data }
          await this.loadMailTemplates()
          this.selected = [ this.template ]
        } catch (e) {
          console.error(e)
        } finally {
          this.loadingTemplate = false
        }
      },
      columnValueList (val) {

        return _.chain(this.items)
          .map(d => _.get(d, val))
          .flatten()
          .filter(Boolean)
          .uniq()
          .value()
      },
      newTemplate () {
        this.template = { new: true, settings: {}, translation: [], entity_id: this.entity_id }
        this.loadingTemplate = false
        this.selected = []
      },
      loadAllTemplates () {
        this.loadMailTemplates()
        this.loadMailTemplate(this.selected[0].template_id)
      },
      selectTemplate (data) {
        if (!data.value) this.template = false
        // this.template = data.value ? Object.assign({}, data.item) : false
        if (data.value) {
          // this.template.settings = {}
        }
        if (data.value) {
          this.loadMailTemplate(data.item.template_id)
        }
      },
      loadMailTemplates (withNotifications = false) {
        const promises = [
          API.call('/mail/template/list.json', {}, null, this.entity_id),
        ]

        if (withNotifications && this.hasNotificationAccess) {
          promises.push(
            API.call('/$v/notification-center/events/list.json', {
              entity_id: this.entity_id,
              event: {
                status: 'active'
              },
            })
          )
        }

        return Promise.all(promises).then(([mailTemplateResponse, notificationListResponse]) => {
          this.items = mailTemplateResponse.data.map(item => ({ ...item, translation: item.translation.map(({ language }) => language).join(',') }))

          if (notificationListResponse) {
            this.notificationOptions = notificationListResponse.data
          }
        })
      },
      loadMailTemplate (template_id) {
        this.loadingTemplate = true
        API.call('/mail/template/item.json', {
          template_id: template_id,
        }, null, this.entity_id).then(resp => {
          return this.template = resp.data
        }).catch(e => {
        }).finally(() => {
          this.loadingTemplate = false
        })
      },
      async deleteTemplate (item) {
        if (await this.$root.$confirm('Confirm', 'Are you sure you want to delete this item?')) {
          API.call('/mail/template/delete.json', {
            template_id: item.template_id,
          }, null, item.entity_id).then(resp => {
            return this.loadMailTemplates()
          }).catch(e => {
          })

        }
      },

      onImport(args) {
        const numberOfTemplates = args.data.length
        const numberOfReplacements = args.replacements.length

        const entityName = this.$store.state.auth.entities.find(entity => entity.entity_id === args.project)?.name
        this.$root.$confirm('Confirm', `Are you sure you want to import ${numberOfTemplates} templates, apply ${numberOfReplacements} replacements and assign them to project ${entityName || args.project}?`)
          .then(yes => {
            if (!yes) {
              return
            }

            this.isImportLoading = true
            return API.call('/mail/template/import.json', {
              templates: args.data,
              entity_id: args.project,
              replacements: args.replacements,
            })
              .then(() => {
                this.isImporting = false
                this.loadMailTemplates()
                this.$showSuccess('Imported successfully')
              })
              .finally(() => {
                this.isImportLoading = false
              })
          })
      }
    },

  }
</script>
